<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="状态" prop="enable">
                    <el-select v-model="queryCondition.enable" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="类型" prop="type">
                    <el-select v-model="queryCondition.type" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in typeOptions" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <!-- <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span> -->
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="QSPI_AAA_TPL_COPY" v-preventReClick size="mini" class="btn" type="primary" @click="copyData">复制</el-button>
        <el-button v-if="statusView=='A'" size="mini" class="btn" type="primary" @click="addData">新增</el-button>
        <el-button v-acl="QSPI_AAA_TPL_COPY" v-preventReClick size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="ellipsis" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="版本" min-width="100" field="version">
          <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row)">{{scope.row.version}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="类型" min-width="100" field="typeView">
          <template v-slot="scope">
            <el-button type="text" @click="onTypeDetail(scope.row)">{{scope.row.typeView}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="状态" min-width="100" field="enable">
          <template v-slot="scope">
            <span>{{scope.row.enable|setEnable}}</span>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="生效时间" min-width="140" field="effectiveDate" show-overflow-tooltip></ux-table-column>
        <!-- <ux-table-column align="center" title="失效时间" min-width="140" field="expireDate"></ux-table-column> -->
        <ux-table-column align="center" title="评分计算规则1" min-width="100" field="ttQspiScoreRuleId1">
          <template v-slot="scope">
            <el-button type="text" @click="examine(scope.row,'one')">查看</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="评分计算规则2" min-width="120" field="ttQspiScoreRuleId2">
          <template v-slot="scope">
            <el-button type="text" @click="examine(scope.row,'two')">查看</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="100" field="updateByName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" min-width="140" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="维护评分模板版本" :visible.sync="showDetailDialog" append-to-body width="50%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData" @close="closeDialog"></detailDialog>
    </el-dialog>

    <el-dialog title="维护评分计算规则" :visible.sync="showScoringRubric" append-to-body width="60%" :close-on-click-modal="false" @close="closeRubricg">
      <scoringRubricDialog v-if="showScoringRubric" :detailInfo="detailInfo" :templateId="templateId" :temStatus="temStatus" @closeRubricg="closeRubricg"></scoringRubricDialog>
    </el-dialog>

  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import detailDialog from './dialog/maintainDialog.vue'
import scoringRubricDialog from './dialog/scoringRubric.vue'
import apiService from "@/api/AAA/index.js";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";

export default {
  name: '',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    detailDialog,
    scoringRubricDialog
  },
  data() {
    return {
      identity: localStorage.getItem('ms_emplFlag'),
      typeOptions: [],
      detailInfo: [],
      multipleSelection: [],
      categoryList2: [{
        value: true,
        label: "启用"
      }, {
        value: false,
        label: "禁用"
      }],
      categoryList3: [],
      statusList: [],
      queryCondition: {
        type: "",
        enable: "",
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      templateId: "",
      showScoringRubric: false,
      showDetailDialog: false,
      temStatus: "",
      tableData: [],
      formData: null,
      statusView: "",
    }
  },
  destroyed() {
    this.$store.dispatch('saveQuery', {})
  },
  created() {
    let queryData = this.$store.state.aaa.scoresQuery
    if (queryData.type) {
      this.$set(this.queryCondition, 'type', queryData.type)
    }
    if (queryData.enable) {
      this.$set(this.queryCondition, 'enable', queryData.enable)
    }
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    let roles = JSON.parse(localStorage.getItem("ms_roles"));

    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      for (let i = 0, len = roles.length; i < len; i++) {
        if (roles[i] == 'QSPI_AAA_ADMIN') {
          this.statusView = 'A';
        } else {
          this.statusView = 'C';
        }
      }
    }
    this.getTypeList()
    this.queryData();
  },
  filters: {
    setEnable(val) {
      if (val) {
        return '启用'
      } {
        return '禁用'
      }
    }
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      sessionStorage.setItem("setQuery", JSON.stringify(this.queryCondition))
      apiService.scoringTemQuery(this.queryCondition).then((res) => {
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
    },
    onDetail(row) {
      sessionStorage.setItem("maintainVersion", row.version)
      this.$router.push({
        path: "/maintainGradeTem",
        query: {
          id: row.ttQspiAppraiseTemplateId,
        }
      })
    },
    onTypeDetail(row) {
      this.showDetailDialog = true
      apiService.getTemInfo(row.ttQspiAppraiseTemplateId).then((res) => {
        this.formData = res.data
      })
    },
    onReset() {
      this.queryCondition = {
        type: "",
        enable: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.$refs['queryCondition'].resetFields();
      this.queryCondition.pageNum = 1
      this.queryData()
    },
    examine(row, status) {
      this.templateId = row.ttQspiAppraiseTemplateId
      this.temStatus = status == 'one' ? 1 : 2
      let type = status == 'one' ? row.ttQspiScoreRuleId1 : row.ttQspiScoreRuleId2
      if (type) {
        apiService.calcRuleDetail(type).then((res) => {
          this.detailInfo = res.resultData
        })
      } else {
        console.log('新增')
      }
      // this.detailInfo=
      this.showScoringRubric = true
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    addData() {
      this.formData = {}
      this.showDetailDialog = true
    },
    onDel() {
      if (this.multipleSelection.length == 1) {
        this.$confirm('请确认是否删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiService.delTemplate(this.multipleSelection[0].ttQspiAppraiseTemplateId).then((res) => {
            console.log("GY🚀 ~ file: maintainScore.vue:232 ~ apiService.delTemplate ~ res:", res);
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.multipleSelection = []
              this.queryData()
            } else {
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } else if (this.multipleSelection.length > 1) {
        this.$message.error('只能勾选一项')
      } else {
        this.$message.error('请勾选数据')
      }
    },
    copyData() {
      if (this.multipleSelection.length == 1) {
        let params = []
        this.multipleSelection.forEach((v) => {
          params.push(v.ttQspiAppraiseTemplateId)
        })
        apiService.copyTemData(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('复制成功')
            this.multipleSelection = []
            this.queryData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (this.multipleSelection.length > 1) {
        this.$message.error('只能勾选一项')
      } else {
        this.$message.error('请勾选数据')
      }

    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    closeDialog() {
      this.showDetailDialog = false
      this.queryData()
    },
    closeRubricg() {
      this.showScoringRubric = false
      this.queryData()
    },
    getTypeList() {
      apiService.getTypeList().then((res) => {
        this.typeOptions = res.resultData
      })
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
